import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import Img from '../../assets/images/illustration/teste-acabou.svg'
import { hasParceria } from "../../utility/Utils"
import './ModalLead.scss'
export default function ModalLead(props) {
  const userState = useSelector((state) => state.auth.userData)
  return (
    <div backdrop={true} fullscreen={'sm'}>
      <div className="modal-teste-lead ">
      </div>
      <div className="container-teste rounded d-flex flex-column gap-1 align-items-center justify-content-center">
        <img src={Img} alt="" />
        <h1>{userState.user.venda_asaas_id !== null && userState.user.venda_asaas_id.length !== 0 ? "Seu plano acabou !" : "Seu período de teste acabou !"}</h1>

        <p className="text-center"> {userState.user.venda_asaas_id !== null && userState.user.venda_asaas_id.length !== 0 ? "Para continuar automatizando o ICMS-ST e DIFAL em sua empresa, realize o pagamento de sua fatura" : "Para continuar automatizando o ICMS-ST e DIFAL na sua empresa, basta contratar um plano."}</p>
        {hasParceria() ? null  : userState.user.venda_asaas_id !== null && userState.user.venda_asaas_id.length !== 0 ? <Link to="/perfil">
          <Button className="font-button w-100" color="primary">Área de faturas</Button>
        </Link> : <a href="https://wa.me/5596988084271?text=Ol%C3%A1+quero+ter+mais+informa%C3%A7%C3%B5es+sobre+o+Tributei" target="_blank" rel="noopener noreferrer">
          <Button className="font-button background-gradiente" color="primary">Quero automatizar meu trabalho manual</Button>
        </a>
        }
      </div>
    </div>
  )
}